<script lang="ts">
	import { PrimaryGalleryPage } from '#lib/websites/primary/pages/PrimaryGalleryPage/index.js';
</script>

<PrimaryGalleryPage />
